// extracted by mini-css-extract-plugin
module.exports = {"privacyContainer":"CookieDeclaration_privacyContainer__18GKK","privacyNavBar":"CookieDeclaration_privacyNavBar__1YuGq","privacyContent":"CookieDeclaration_privacyContent__3etVF"};